import { render, staticRenderFns } from "./BlockPriceCategoryListDuplicate.vue?vue&type=template&id=85ee4ebe&scoped=true"
import script from "./BlockPriceCategoryListDuplicate.vue?vue&type=script&lang=js"
export * from "./BlockPriceCategoryListDuplicate.vue?vue&type=script&lang=js"
import style0 from "./BlockPriceCategoryListDuplicate.vue?vue&type=style&index=0&id=85ee4ebe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ee4ebe",
  null
  
)

export default component.exports